import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Range } from '../../common/core/range.js';
import { Selection } from '../../common/core/selection.js';
export var MoveCaretCommand = /*#__PURE__*/function () {
  function MoveCaretCommand(selection, isMovingLeft) {
    _classCallCheck(this, MoveCaretCommand);

    this._selection = selection;
    this._isMovingLeft = isMovingLeft;
  }

  _createClass(MoveCaretCommand, [{
    key: "getEditOperations",
    value: function getEditOperations(model, builder) {
      if (this._selection.startLineNumber !== this._selection.endLineNumber || this._selection.isEmpty()) {
        return;
      }

      var lineNumber = this._selection.startLineNumber;
      var startColumn = this._selection.startColumn;
      var endColumn = this._selection.endColumn;

      if (this._isMovingLeft && startColumn === 1) {
        return;
      }

      if (!this._isMovingLeft && endColumn === model.getLineMaxColumn(lineNumber)) {
        return;
      }

      if (this._isMovingLeft) {
        var rangeBefore = new Range(lineNumber, startColumn - 1, lineNumber, startColumn);
        var charBefore = model.getValueInRange(rangeBefore);
        builder.addEditOperation(rangeBefore, null);
        builder.addEditOperation(new Range(lineNumber, endColumn, lineNumber, endColumn), charBefore);
      } else {
        var rangeAfter = new Range(lineNumber, endColumn, lineNumber, endColumn + 1);
        var charAfter = model.getValueInRange(rangeAfter);
        builder.addEditOperation(rangeAfter, null);
        builder.addEditOperation(new Range(lineNumber, startColumn, lineNumber, startColumn), charAfter);
      }
    }
  }, {
    key: "computeCursorState",
    value: function computeCursorState(model, helper) {
      if (this._isMovingLeft) {
        return new Selection(this._selection.startLineNumber, this._selection.startColumn - 1, this._selection.endLineNumber, this._selection.endColumn - 1);
      } else {
        return new Selection(this._selection.startLineNumber, this._selection.startColumn + 1, this._selection.endLineNumber, this._selection.endColumn + 1);
      }
    }
  }]);

  return MoveCaretCommand;
}();